__turbopack_context__.v({
  "bulkAlert": "MoveModal-module__6erwDW__bulkAlert",
  "bulkSpinner": "MoveModal-module__6erwDW__bulkSpinner",
  "clearButton": "MoveModal-module__6erwDW__clearButton",
  "createButton": "MoveModal-module__6erwDW__createButton",
  "ctaButtons": "MoveModal-module__6erwDW__ctaButtons",
  "destinationDisclaimer": "MoveModal-module__6erwDW__destinationDisclaimer",
  "folderFilterRow": "MoveModal-module__6erwDW__folderFilterRow",
  "folderSharingAlert": "MoveModal-module__6erwDW__folderSharingAlert",
  "folderTreeContainer": "MoveModal-module__6erwDW__folderTreeContainer",
  "folderTreeWrapper": "MoveModal-module__6erwDW__folderTreeWrapper",
  "footer": "MoveModal-module__6erwDW__footer",
  "form": "MoveModal-module__6erwDW__form",
  "search": "MoveModal-module__6erwDW__search",
});
